import { FC } from "react";
import { Box, Typography } from "@mui/material";
import { CustomButton } from "../../../components";
import CustomModal from "../../../components/common/custom-modal/custom-modal";
import { pxToRem } from "../../../util";
import { Colors } from "../../../configs";

interface IScanWarningModalProps {
  open: boolean;
  onClose: () => void;
  /**
   * Why the scan was rejected. The conveyor screen raises this modal from several
   * unrelated conditions — a malformed location code, an unknown slot, a duplicate,
   * a server-side conflict — so the caller supplies the reason rather than the modal
   * assuming one.
   */
  message?: string;
}

const DEFAULT_MESSAGE =
  "You have scanned the same invoice. Please avoid duplicates and continue scanning!";

export const ScanWarningModal: FC<IScanWarningModalProps> = ({
  open,
  onClose,
  message,
}) => {
  return (
    <CustomModal
      openModal={open}
      onClose={onClose}
      title="Warning!"
      width={pxToRem(564)}
      height={pxToRem(377)}
      titleSize="2rem"
      titleColor="#930000"
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "center",
          height: "100%",
          paddingTop: pxToRem(10),
          paddingBottom: pxToRem(50),
        }}
      >
        <Typography
          sx={{
            fontSize: "var(--fs-base)",
            color: Colors.TEXT_GRAY_DARK,
            textAlign: "center",
            fontWeight: 400,
            marginTop: pxToRem(10),
          }}
        >
          {message || DEFAULT_MESSAGE}
        </Typography>

        <CustomButton
          sx={{
            width: pxToRem(467),
            height: pxToRem(64),
            fontSize: pxToRem(24),
            background: Colors.PRIMARY,
          }}
          onClick={onClose}
        >
          Got It
        </CustomButton>
      </Box>
    </CustomModal>
  );
};

export default ScanWarningModal;
